import React, { useEffect, useRef, useState } from "react";
import Cleave from "cleave.js/react";

// Addons de telefone por país
import 'cleave.js/dist/addons/cleave-phone.br';
import 'cleave.js/dist/addons/cleave-phone.us';
import 'cleave.js/dist/addons/cleave-phone.pt'; // adicione outros se quiser

const countryOptions = [
  { code: "BR", label: "🇧🇷" },
  { code: "US", label: "🇺🇸" },
  { code: "PT", label: "🇵🇹" }
];

const TextQuestion = ({ question, value = "", onChange, onBlur }) => {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(value);
  const [countryCode, setCountryCode] = useState("BR");

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const getCleaveOptions = () => {
    switch (question.mask) {
        case "dateBR":
          return { date: true, delimiter: "/", datePattern: ["d", "m", "Y"] };
        case "decimal":
          return { numeral: true, numeralDecimalMark: ".", delimiter: "" };
        case "weight":
          return { blocks: [3], numericOnly: true };
        case "height":
          return {
              blocks: [3],
              numericOnly: true,
          };
        case "phoneBR":
          return { phone: true, phoneRegionCode: "BR" };
        case "phoneUS":
          return { phone: true, phoneRegionCode: "US" };
        case "creditCard":
          return { creditCard: true };
        case "cpf":
          return {
              delimiters: [".", ".", "-"],
              blocks: [3, 3, 3, 2],
              numericOnly: true,
          };
        case "cnpj":
          return {
              delimiters: [".", ".", "/", "-"],
              blocks: [2, 3, 3, 4, 2],
              numericOnly: true,
          };
        case "cepBR":
          return { delimiters: ["-"], blocks: [5, 3], numericOnly: true };
        case "phoneDynamic":
            switch (countryCode) {
                case "BR":
                  return {
                      delimiters: ["(", ") ", "-", ""],
                      blocks: [0, 2, 5, 4],
                      numericOnly: true,
                  };
                case "US":
                  return {
                      delimiters: ["(", ") ", "-", ""],
                      blocks: [0, 3, 3, 4],
                      numericOnly: true,
                  };
                case "PT":
                  return {
                      blocks: [3, 3, 3],
                      delimiters: [" ", " "],
                      numericOnly: true,
                  };
                default:
                  return { phone: true, phoneRegionCode: countryCode };
            }
            default:
              return null;
        }
    };

  const handleChange = (e) => {
    const val = e.target.value;
    setLocalValue(val);
    onChange(val);
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e.target.value);
  };

  const maskOptions = getCleaveOptions();

  return (
    <div className="question text-question row mx-0 align-items-center">
      <div className="chat-label col-lg-5">{question.label}</div>

      <div className="chat-answer user position-relative col-lg-7 px-0">
        <div className="row mx-0">
            {question.mask === "phoneDynamic" && (
            <div className="col-auto px-0">
                <select
                    className="form-select"
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                >
                    {countryOptions.map((c) => (
                    <option key={c.code} value={c.code}>
                        {c.label}
                    </option>
                    ))}
                </select>
            </div>
            )}

            <div className="col px-0">{maskOptions ? (
                <Cleave
                    key={question.mask === 'phoneDynamic' ? countryCode : question.mask}
                    ref={inputRef}
                    options={maskOptions}
                    value={localValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={question.placeholder}
                    required={question.optional === 0}
                    />
                ) : (
                <input
                    ref={inputRef}
                    type="text"
                    value={localValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder={question.placeholder}
                    required={question.optional === 0}
                />
                )}
            </div>
        </div>
        {question.sym_explain && <small>{question.sym_explain}</small>}
      </div>
    </div>
  );
};

export default TextQuestion;